module.exports = [// Form.
'button', 'input', 'select', 'textarea'];